import * as S from "./DataStudio.style";

function DataStudio ({
  processID
}) {

  return (
    <S.DataStudio>
      {
        processID === 47 && 
        <>
          <div className="frame">
            <iframe
              width="100%"
              height="100%"
              src="https://lookerstudio.google.com/embed/reporting/da769d8f-7698-401d-8241-51cd2a2b1d13/page/tPWVF"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            ></iframe>
          </div>
          <div className="frame">
            <iframe
              width="100%"
              height="100%"
              src="https://lookerstudio.google.com/embed/reporting/810b135e-2371-4838-8dbd-cefa735ea273/page/4XRVF"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen
              sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            ></iframe>
          </div>
        </>
      }
      {
        processID === 68 &&
        <div className="frame">
          <iframe
            width="100%"
            height="100%"
            src="https://lookerstudio.google.com/embed/reporting/aa921e34-8f0a-49ca-bb50-8619cf2394e7/page/p_wsz5f4mmwd"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
          ></iframe>
        </div>
      }
    </S.DataStudio>
  )

}

export default DataStudio;
